export const ALLOWED_STAGES_FOR_JOBS_BUDGETS = [6, 7];
